class OccupationGroup {
  constructor(payload) {
    if (!payload) return;
    this.id = payload.id || null;
    this.name = payload.name || null;
  }
}

export { OccupationGroup };
